// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2xf48","header":"Messages_header__2E8cs"};